
document.addEventListener("DOMContentLoaded", (event) => {
    const isProdPage = BSS_B2B.page.isProductPage()
    if(!isProdPage) return
    
    // const priEle = document.querySelector("[bss-b2b-variant-id] .text-lg")
  const interval = setInterval(() => {
    BSS_B2B.observer?.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
  }, 100); 


  
  setTimeout(() => {
    clearInterval(interval)
    // if(priEle) {
    //     priEle.style.visibility = 'visible'
    // }
  }, 2000);
});

  let app = document.querySelectorAll('.shopify-block:has(.sqarp-addon-categories) , .shopify-block:has(.sqarp-accessory-section)')
  let bss= document.querySelector('.bss')
  app.forEach(element => {
    bss.after(element)
  });
